import { PersonaList } from '@/features/personas/components/PersonaList'
import { useTranslation } from 'react-i18next'

export function PersonasPage() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-surface-50">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="text-2xl font-bold text-neutral-900 mb-8">{t('personas.page_title')}</h1>
        <PersonaList />
      </div>
    </div>
  )
}
